import { z } from 'zod';
import { DocumentIndex } from './DocumentIndexes';

const commonParamInputSchema = z.object({
    inputKey: z.string().trim().min(1),
    label: z.string().trim().min(1),
});

const stringParamInputSchema = z
    .object({
        type: z.literal('string'),
        defaultValue: z.string().optional(),
    })
    .merge(commonParamInputSchema);

const numberParamInputSchema = z
    .object({
        type: z.literal('number'),
        defaultValue: z.number().optional(),
    })
    .merge(commonParamInputSchema);

const booleanParamInputSchema = z
    .object({
        type: z.literal('boolean'),
        defaultValue: z.boolean().optional(),
    })
    .merge(commonParamInputSchema);

const arrayStringParamInputSchema = z
    .object({
        type: z.literal('Array<string>'),
        defaultValue: z.array(z.string()).optional(),
    })
    .merge(commonParamInputSchema);

const arrayNumberParamInputSchema = z
    .object({
        type: z.literal('Array<number>'),
        defaultValue: z.array(z.number()).optional(),
    })
    .merge(commonParamInputSchema);

export const paramInputSchema = z.discriminatedUnion('type', [
    stringParamInputSchema,
    numberParamInputSchema,
    booleanParamInputSchema,
    arrayStringParamInputSchema,
    arrayNumberParamInputSchema,
]);

type ParamInput = z.infer<typeof paramInputSchema>;

export type ConfigParamValueType = NonNullable<ParamInput['defaultValue']>;

export type ConfigParamDefinition = {
    name: string;

    /**
     * @deprecated
     *
     * Use `inputs` array instead
     */
    label: string;

    description: string;

    /**
     * @deprecated
     *
     * Use `inputs` array instead
     */
    type: ParamInput['type'];

    /**
     * @deprecated
     *
     * Use `inputs` array instead
     */
    defaultValue?: ConfigParamValueType;

    configurableByCompany: boolean;

    errorCode: string;

    inputs?: ParamInput[];

    documentIndexes?: DocumentIndex[];

    configurableErrorTexts?: boolean;
};
